import { Component, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { DataService } from '../../data.service';

@Component({
  selector: 'lc-pin-page',
  templateUrl: './pin-page.component.html',
  styleUrls: ['./pin-page.component.scss']
})
export class PinPageComponent implements OnInit {

  password = '';
  returnUrl = '';
  pin = '789654';
  password_is_valid = false;
  wrong_password: boolean;
  chars = ['1','2','3','4','5','6','7','8','9','clear','0','x'];

  constructor(private dataService: DataService, private router: Router, private route: ActivatedRoute) { }

	
	// listen to keyboard input to make it easier to enter pin on a desktop
  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
		const inArray = this.chars.includes(event.key);
		if(inArray) {
			this.pushChar(event.key);
		} else if (event.code === 'Backspace') {
			this.pushChar('x');
		}
  };  

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl']
  }

  verifyPassword() {
  	if(this.password === this.pin) {
    this.password_is_valid = true;
    this.setPassword();
  	}
  	else {
			this.dataService.presentMessage('You\'ve entered the wrong code. Please try again or ask for assistance.', 'warning');
			this.wrong_password = true;
			this.password = '';
  	}
	}
	
	pushChar(char: string) {
		if (char === '' || !char || char === undefined) {
			// do nothing
		} else if (char === 'x') {
			this.removeChar();
		} else if(char === 'clear') {
			this.password = '';
		} else {
			this.password = this.password + char;
			if (this.password.length === 6) {
				this.verifyPassword();
			}
		}
	}

	removeChar() {
		this.password = this.password.slice(0, -1);
  }  
  
  // save the pin timestamp in localstorage, move to the ids page. 
  // TODO: make this into a component which could be put in front of something instead of a page.
  setPassword() {
    window.localStorage.setItem('pincode_entered', JSON.stringify(new Date()));
    this.router.navigateByUrl(this.returnUrl);
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/pin-page/pin-page.component.ts